// src/components/relatorios/TabelaMargemCritica.js
import React from 'react';

const TabelaMargemCritica = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
        Nenhuma OS encontrada
      </div>
    );
  }

  const n = (v) => {
    const x = Number(v);
    return Number.isFinite(x) ? x : 0;
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(n(valor));
  };

  const getMargemColor = (margem) => {
    const m = n(margem);
    if (m < 20) return '#ef4444';
    if (m < 40) return '#f59e0b';
    return '#10b981';
  };

  const getMargemIcon = (margem) => {
    const m = n(margem);
    if (m < 20) return '🔴';
    if (m < 40) return '🟡';
    return '🟢';
  };

  const getMargemStatus = (margem) => {
    const m = n(margem);
    if (m < 20) return 'Crítico';
    if (m < 40) return 'Atenção';
    return 'Aceitável';
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ backgroundColor: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
              <th style={{ padding: '12px', textAlign: 'left', color: '#374151', fontWeight: '600' }}>
                Cliente / OS
              </th>
              <th style={{ padding: '12px', textAlign: 'right', color: '#374151', fontWeight: '600' }}>
                Valor Total
              </th>
              <th style={{ padding: '12px', textAlign: 'right', color: '#374151', fontWeight: '600' }}>
                Custo
              </th>
              <th style={{ padding: '12px', textAlign: 'right', color: '#374151', fontWeight: '600' }}>
                Lucro
              </th>
              <th style={{ padding: '12px', textAlign: 'center', color: '#374151', fontWeight: '600' }}>
                Margem
              </th>
              <th style={{ padding: '12px', textAlign: 'center', color: '#374151', fontWeight: '600' }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((os, index) => {
              const margem = n(os.margem_percentual);
              const margemColor = getMargemColor(margem);

              return (
                <tr
                  key={os.id}
                  style={{
                    borderBottom: '1px solid #e5e7eb',
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb'
                  }}
                >
                  <td style={{ padding: '12px' }}>
                    <div style={{ fontWeight: '600', color: '#374151', marginBottom: '4px' }}>
                      {os.cliente || 'Cliente não informado'}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {os.titulo}
                    </div>
                  </td>

                  <td style={{ padding: '12px', textAlign: 'right', fontWeight: '600', color: '#374151' }}>
                    {formatarMoeda(os.valor_total)}
                  </td>

                  <td style={{ padding: '12px', textAlign: 'right' }}>
                    <div style={{ fontWeight: '600', color: '#dc2626' }}>
                      {formatarMoeda(os.custo_total)}
                    </div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>
                      {n(os.percentual_custo).toFixed(1)}% do total
                    </div>
                  </td>

                  <td style={{ padding: '12px', textAlign: 'right', fontWeight: '600', color: '#059669' }}>
                    {formatarMoeda(os.lucro)}
                  </td>

                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <div style={{
                      display: 'inline-block',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      backgroundColor: `${margemColor}20`,
                      border: `2px solid ${margemColor}`,
                      fontWeight: '700',
                      color: margemColor,
                      fontSize: '16px'
                    }}>
                      {margem.toFixed(1)}%
                    </div>
                  </td>

                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                      <span style={{ fontSize: '20px' }}>
                        {getMargemIcon(margem)}
                      </span>
                      <span style={{ fontSize: '11px', color: margemColor, fontWeight: '600' }}>
                        {getMargemStatus(margem)}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{
        marginTop: '20px',
        padding: '12px',
        backgroundColor: '#f9fafb',
        borderRadius: '8px',
        display: 'flex',
        gap: '20px',
        fontSize: '12px',
        justifyContent: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>🔴</span>
          <span style={{ color: '#6b7280' }}>Crítico (&lt; 20%)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>🟡</span>
          <span style={{ color: '#6b7280' }}>Atenção (20-40%)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>🟢</span>
          <span style={{ color: '#6b7280' }}>Aceitável (&gt; 40%)</span>
        </div>
      </div>
    </div>
  );
};

export default TabelaMargemCritica;
